import ActiveUser from './models/activeUser';

export const isAuthenticated = (user?: ActiveUser) => {
    return !!user && user.hasOwnProperty('email') && user.active_account &&
        (!user.hasOwnProperty('is_authenticated') || user.is_authenticated);
};